import { Shield } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <Shield className="w-12 h-12 text-primary-500 mx-auto mb-4" />
          <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Privacy Policy
          </h1>
          <p className="text-lg text-gray-600">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>

        <div className="prose prose-lg max-w-none">
          <p>
            At Egg Time On, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Information We Collect</h2>
          
          <h3 className="font-display text-xl font-semibold mt-6 mb-3">Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide to us when you:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Contact us through our contact form</li>
            <li>Subscribe to our newsletter</li>
            <li>Participate in surveys or promotions</li>
            <li>Provide feedback or comments</li>
          </ul>
          <p>
            This information may include your name, email address, and any other information you choose to provide.
          </p>

          <h3 className="font-display text-xl font-semibold mt-6 mb-3">Non-Personal Information</h3>
          <p>
            We automatically collect certain non-personal information when you visit our website, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>IP address</li>
            <li>Time and date of your visit</li>
            <li>Pages you visit</li>
            <li>Referral sources</li>
          </ul>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">How We Use Your Information</h2>
          <p>
            We may use the information we collect for various purposes, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Providing, maintaining, and improving our website</li>
            <li>Responding to your inquiries and requests</li>
            <li>Sending newsletters and marketing communications (if you've subscribed)</li>
            <li>Analyzing usage patterns to enhance user experience</li>
            <li>Preventing fraudulent activities and ensuring the security of our website</li>
          </ul>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Cookies and Similar Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our website and store certain information. Cookies are files with a small amount of data that may include an anonymous unique identifier.
          </p>
          <p>
            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Third-Party Services</h2>
          <p>
            Our website may contain links to third-party websites or services that are not owned or controlled by Egg Time On. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Children's Privacy</h2>
          <p>
            Our website is not intended for use by children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
          <p>
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul className="list-disc pl-6 mb-4">
          <li>By visiting our contact page: <a href="/contact" className="text-primary-600 hover:text-primary-700">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;